/* eslint-disable react/no-unescaped-entities,react/prop-types */
import Alphapharm from '../src/components/Pages/Company/About/Alphapharm'
import MobileDetect from 'mobile-detect'
import { useRouter } from 'next/router'
import React from 'react'
import Head from 'next/head'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'

export default function AlphapharmIndex(props) {
    const router = useRouter()
    return (
        <React.Fragment>
            <Head>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                <title>ООО "АльфаФарм" - сеть аптек ЗДОРОВ.ру</title>
            </Head>
            {/* eslint-disable-next-line react/prop-types */}
            {props.mobile && (
                <MobileHeader
                    backClickHandler={async () => {
                        await router.push('/account')
                    }}>
                    ООО "АльфаФарм"
                </MobileHeader>
            )}
            <Alphapharm isMobile={props.mobile} />
        </React.Fragment>
    )
}

export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    async customize({ context }) {
        const md = new MobileDetect(context.req.headers['user-agent'])
        return {
            props: {
                mobile: md.mobile()
            }
        }
    }
})
